<template>
  <th class="default-table-head" :style="custom_style" v-bind="$attrs">
    <slot></slot>
  </th>
</template>

<script lang="ts">
export default {
  props: {
    custom_style: {
      default: '',
      required: false,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.default-table-head {
  padding: 0 0.5rem;
}
</style>
